/*

  Helper of Quality Seal Portal

*/

let qualitySealPortalHelper = {

    // Ajax helper functions

    ajaxCallGet: function (url, type) {
        return $.ajax({
            url: url,
            type: type,
        });
    },

    ajaxCallPost: function (url, type, datatype, data) {
        return $.ajax({
            url: url,
            type: type,
            datatype: datatype,
            data: data
        });
    },

    ajaxCallPostForRemoving: function (url, type, datatype, uid) {
        return $.ajax({
            url: url,
            type: type,
            dataType: datatype,
            data: {
                tx_psrqualitysealportal_conservationunit: {
                    uid: uid
                }
            },
        })
    },
}

export default qualitySealPortalHelper
